export enum DeviceTypes {
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    UNKNOWN = 'UNKNOWN',
}

export enum WebviewDevices {
    ANDROID = 'ANDROID',
    ANDROIDAPPTABLET = 'ANDROIDAPPTABLET',
    iPHONE = 'iPHONE',
    iPAD = 'iPAD',
}

export type DeviceType = keyof typeof DeviceTypes;
export type WebviewDevice = keyof typeof WebviewDevices;

export type AppshellMeta = {
    isApp: boolean;
    getDeviceTypeByUserAgent: () => DeviceType;
    webviewDevice?: WebviewDevice;
    mobileAppWebviewVersion?: string;
};
